import { render, staticRenderFns } from "./ParentConnectHome.vue?vue&type=template&id=0c2821b8&scoped=true"
import script from "./ParentConnectHome.vue?vue&type=script&lang=js"
export * from "./ParentConnectHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2821b8",
  null
  
)

export default component.exports